import { Upload, ChevronDown, FileText, Globe, Ticket, BookOpen } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger
} from '@/components/ui/dropdown-menu';

export type AddSourceKind = 'documents' | 'links' | 'tickets' | 'article' | 'google';

interface AddSourcesMenuProps {
  onSelect: (kind: AddSourceKind) => void;
  disabled?: boolean;
}

export function AddSourcesMenu({ onSelect, disabled }: AddSourcesMenuProps) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant='default' className='h-8 gap-1 flex text-xs' disabled={disabled}>
          <Upload className='size-4' /> Add Sources <ChevronDown className='size-3.5' />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align='end' className='w-56'>
        <DropdownMenuLabel className='text-[10px] text-muted-foreground font-medium'>Existing sources</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => onSelect('documents')} className='gap-2'>
          <FileText className='size-4' /> Document
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect('links')} className='gap-2'>
          <Globe className='size-4' /> Website links
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect('tickets')} className='gap-2'>
          <Ticket className='size-4' /> Past Tickets
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onSelect('google')} className='gap-2'>
          <img src='/assets/brand/google-mono.svg' alt='' className='size-4' /> Google Docs & Sheets
        </DropdownMenuItem>
        <DropdownMenuSeparator />
        <DropdownMenuLabel className='text-[10px] text-muted-foreground font-medium'>New Source</DropdownMenuLabel>
        <DropdownMenuItem onClick={() => onSelect('article')} className='gap-2'>
          <BookOpen className='size-4' /> Create Article
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
